// @flow
import { SeccionesActionTypes } from './constants';

type SeccionesAction = { type: string, payload: {} | string };

// common success
export const seccionesApiResponseSuccess = (actionType: string, data: any): SeccionesAction => ({
    type: SeccionesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const seccionesApiResponseError = (actionType: string, error: string): SeccionesAction => ({
    type: SeccionesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getSeccion = (id: string): SeccionesAction => ({
    type: SeccionesActionTypes.GET_SECCION,
    payload: { id },
});

export const addSeccion = (seccion:any):SeccionesAction=>({
    type:SeccionesActionTypes.ADD_SECCION,
    payload:seccion
})
export const updateSeccion = (seccion:any):SeccionesAction=>({
    type:SeccionesActionTypes.UPDATE_SECCION,
    payload:seccion
})
export const deleteSeccion = (id:string):SeccionesAction=>({
    type:SeccionesActionTypes.DELETE_SECCION,
    payload:{id}
})

export const listSecciones = (params:any): SeccionesAction => ({
    type: SeccionesActionTypes.LIST_SECCIONES,
    payload: params,
});


export const resetSecciones = (): SeccionesAction => ({
    type: SeccionesActionTypes.RESET,
    payload: {},
});

